import { render } from "./LeadAreasTable.vue?vue&type=template&id=0d03747b"
import script from "./LeadAreasTable.vue?vue&type=script&lang=js"
export * from "./LeadAreasTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__